export const t20RankingsStub = {
    batsmen: {
        rank: [
            {
                id: "56789",
                rank: "1",
                name: "Babar Azam",
                country: "Pakistan",
                rating: "820",
                points: "820",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "170768"
            },
            // ... other batsmen
        ]
    },
    bowlers: {
        rank: [
            {
                id: "67890",
                rank: "1",
                name: "Rashid Khan",
                country: "Afghanistan",
                rating: "800",
                points: "800",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184120"
            },
            // ... other bowlers
        ]
    },
    allrounders: {
        rank: [
            {
                id: "78901",
                rank: "1",
                name: "Mohammad Nabi",
                country: "Afghanistan",
                rating: "790",
                points: "790",
                lastUpdatedOn: "2022-04-26",
                trend: "Flat",
                faceImageId: "184121"
            },
            // ... other allrounders
        ]
    },
    teams: {
        rank: [
            {
                id: "3",
                rank: "1",
                name: "Australia",
                rating: "130",
                points: "3240",
                matches: "25"
            },
            // ... other teams
        ]
    }
};
